export default __webpack_public_path__ + "static/media/certificate.c20e84cd.pdf";